<script setup lang="ts">
</script>
<template>
  <div class="flex-1">
    <slot />
  </div>
</template>
